module.exports = __webpack_public_path__ + "c10a4cec417b94ccd22317d3d8d9ac4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gift-s.png
// module id = 2040
// module chunks = 0